import { PublicClientApplication } from '@azure/msal-browser';

// Waive staff/admins authenticate against the CORPORATE WORKFORCE Entra ID tenant — NOT the
// consumer Entra External ID (CIAM) tenant used by the webapp. This is a deliberate identity
// decision: admins are employees, so privileged access inherits MFA / conditional access / PIM
// and corporate joiner-mover-leaver lifecycle. See docs/adr/0001-identity-and-access-model.md.
//
// All three values come from the spoke/entra terraform outputs and are baked in at build time
// via the host-local .env (REACT_APP_* — never committed). There is no native in-app form here:
// native auth is an External ID feature and is not available on a workforce tenant, so this app
// uses the standard Authorization Code + PKCE redirect flow against the hosted login page.
const tenantId = process.env.REACT_APP_ENTRA_TENANT_ID;
const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;

// Scope for the waive-services API. The resulting access token's audience is the API, and it
// carries the signed-in user's app roles (including `waive-admin`) in the `roles` claim, which
// the backend's require_admin dependency enforces.
export const apiScope = process.env.REACT_APP_ENTRA_API_SCOPE;

export const msalConfig = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        // The SPA is served at its origin root; Entra redirects back here and MSAL completes the
        // flow via handleRedirectPromise() on load. Trailing slash is required: the azuread
        // provider registers the redirect URI as https://<host>/ (no-path URIs must end in /),
        // and this must match exactly.
        redirectUri: `${window.location.origin}/`,
        postLogoutRedirectUri: `${window.location.origin}/`,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        // sessionStorage — session-scoped, cleared on tab close (consistent with ADR-0016).
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

// Interactive sign-in: openid/profile to authenticate + the API scope so we can silently
// acquire a waive-services access token immediately afterwards.
export const loginRequest = { scopes: ['openid', 'profile', apiScope].filter(Boolean) };
export const apiTokenRequest = { scopes: [apiScope].filter(Boolean) };

export const msalInstance = new PublicClientApplication(msalConfig);

// msal-browser v3+ requires initialize() to complete before any other API call. Everything in
// authService awaits this promise.
export const msalReady = msalInstance.initialize();
